export type GitHubLoadState = 'idle' | 'loading' | 'ready' | 'error';

type RunToolCardKind = 'model' | 'skill';
type RunToolCoverage = 'free' | 'deep';

export interface GitHubAppConfigResponse {
  configured: boolean;
  appSlug?: string;
  installUrl?: string;
  connectUrl?: string;
  missing?: string[];
}

export interface GitHubInstallationSummary {
  id: number;
  account: {
    login: string;
    type?: string;
    avatarUrl?: string;
  };
  targetType?: string;
  repositorySelection?: string;
  htmlUrl?: string;
  appSlug?: string;
}

export interface GitHubRepositorySummary {
  id: number;
  owner: string;
  repo: string;
  fullName: string;
  private: boolean;
  htmlUrl?: string;
  defaultBranch?: string;
  permissions?: Record<string, boolean>;
}

export interface GitHubRepositoryBranchSummary {
  name: string;
  default: boolean;
  protected?: boolean;
  commitSha?: string;
}

export interface GitHubRepositoryDirectorySummary {
  path: string;
  name: string;
  depth: number;
}

export interface AccountUser {
  id: string;
  githubLogin: string;
  githubAvatarUrl?: string;
  email?: string;
}

export interface Workspace {
  id: string;
  ownerUserId: string;
  name: string;
  slug: string;
  scope?: WorkspaceScope;
  createdAt: string;
  updatedAt: string;
}

export interface WorkspaceScope {
  installationId: number;
  repositoryId: number;
  owner?: string;
  repo?: string;
  branch: string;
  scopePaths: string[];
  scanType?: 'smart-contract' | 'web-api';
  assumptionsFilePath?: string;
  codebaseResourceId?: string;
}

export interface WorkspaceScanSummary {
  id: string;
  workspaceId: string;
  createdByUserId: string;
  scanType: string;
  target: string;
  status: string;
  sourceType: string;
  branch?: string;
  resultEmail?: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
}

export interface RunToolCard {
  id: string;
  kind: RunToolCardKind;
  coverage: RunToolCoverage;
  title: string;
  description: string;
  logo?: string;
  tag?: string;
}

export const runFormatNumber = (value: number): string => {
  return new Intl.NumberFormat('en-US').format(value);
};

export const runGetScopeParentPath = (scopePath: string): string | null => {
  const parentSeparatorIndex = scopePath.lastIndexOf('/');

  return parentSeparatorIndex === -1 ? null : scopePath.slice(0, parentSeparatorIndex);
};

export const runGetScopeAncestorPaths = (scopePath: string): string[] => {
  const ancestors: string[] = [];
  let parentPath = runGetScopeParentPath(scopePath);

  while (parentPath) {
    ancestors.unshift(parentPath);
    parentPath = runGetScopeParentPath(parentPath);
  }

  return ancestors;
};
